export default "__VITE_ASSET__CiLuOfKy__"